import type {
	PlainSettingForDesignPlainQuery,
	PlainWidgetForDesignPlainQuery,
	SnackListForDesignPlainQuery,
} from "@/lib/gql/__generated__/graphql";

import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { PlainSettingInputZodSchemaType } from "./validation-schema";

// 必須の項目がないので拡張しない
const _excludeKeys = [
	"hotelID",
	"backgroundImage",
	"backgroundType",
	"domainName",
	"fontFamily",
	"isShowHotelCatchCopy",
	"isShowHotelKeyVisual",
	"isShowHotelLogo",
	"isShowHotelName",
	"isShowMagazineAbout",
	"isShowMagazinePlan",
	"isShowMagazineRoom",
	"logoSize",
	"reservationComponentType",
	"reservationComponentViewerOrder",
	"plainWidgetDefault",
	"widgetDecoration",
	"guestPageVisibility",
] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type QueryData = {
	plainSetting: PlainSettingForDesignPlainQuery["plainSetting"];
	hotel: PlainSettingForDesignPlainQuery["hotel"];
	planList: PlainSettingForDesignPlainQuery["planList"];
	roomList: PlainSettingForDesignPlainQuery["roomList"];
	plainWidgetDefault: PlainWidgetForDesignPlainQuery["plainWidget"];
	snackList: SnackListForDesignPlainQuery["snackList"];
	/** 公開設定（プレーンの「検索に表示しない」をこのフォームで一緒に保存する） */
	guestPageVisibilitySettings: PlainSettingForDesignPlainQuery["guestPageVisibilitySettings"];
};

export type PlainSettingFormModel = AutoGeneratorForFormModel<PlainSettingInputZodSchemaType, ExcludeKeys, QueryData>;
